(function () {
  var form = document.getElementById('ProductForm');
  if (!form) return;

  var variantIdInput = form.querySelector('[data-variant-id]');
  var swatches = form.querySelectorAll('[data-option-value]');
  var submitBtn = form.querySelector('[data-add-to-cart]');
  var submitText = form.querySelector('[data-add-to-cart-text]');

  // --- Gallery ---
  var thumbs = document.querySelectorAll('[data-gallery-thumb]');
  var slides = document.querySelectorAll('[data-gallery-slide]');

  function activateGallery(index) {
    index = String(index);
    thumbs.forEach(function (t) { t.classList.remove('is-active'); });
    slides.forEach(function (s) { s.classList.remove('is-active'); });

    var thumb = document.querySelector('[data-gallery-thumb][data-index="' + index + '"]');
    var slide = document.querySelector('[data-gallery-slide][data-index="' + index + '"]');

    if (thumb) {
      thumb.classList.add('is-active');
      if (thumb.scrollIntoView) {
        thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    }
    if (slide) slide.classList.add('is-active');
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      activateGallery(thumb.getAttribute('data-index'));
    });
  });

  // --- Quantity stepper ---
  var qtyInput = document.getElementById('Quantity');
  var decreaseBtn = document.querySelector('[data-qty-decrease]');
  var increaseBtn = document.querySelector('[data-qty-increase]');
  if (decreaseBtn) {
    decreaseBtn.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = Math.max(1, val - 1);
    });
  }
  if (increaseBtn) {
    increaseBtn.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = val + 1;
    });
  }

  // --- Product options ---
  var selected = {};
  swatches.forEach(function (btn) {
    var index = btn.getAttribute('data-option-index');
    if (!(index in selected)) {
      var group = form.querySelectorAll('[data-option-index="' + index + '"]');
      var active = Array.prototype.find.call(group, function (b) { return b.classList.contains('is-selected'); });
      selected[index] = active ? active.getAttribute('data-option-value') : group[0].getAttribute('data-option-value');
    }
    btn.addEventListener('click', function () {
      var group = form.querySelectorAll('[data-option-index="' + index + '"]');
      group.forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      selected[index] = btn.getAttribute('data-option-value');
      updateVariant();
    });
  });

  function updateVariant() {
    if (!window.__productVariants) return;
    var match = window.__productVariants.find(function (variant) {
      return Object.keys(selected).every(function (idx) {
        return variant.options[idx] === selected[idx];
      });
    });

    if (match) {
      variantIdInput.value = match.id;
      var available = match.available;
      submitBtn.disabled = !available;
      submitText.textContent = available ? 'Dodaj do koszyka' : 'Niedostępny';

      if (match.featured_media && match.featured_media.position) {
        activateGallery(match.featured_media.position - 1);
      } else if (match.featured_image && match.featured_image.position) {
        activateGallery(match.featured_image.position - 1);
      }

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
  }

  // --- Add to cart via AJAX so the header cart-count updates without reload ---
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    submitBtn.disabled = true;
    var originalText = submitText.textContent;
    submitText.textContent = 'Dodawanie…';

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: variantIdInput.value,
        quantity: parseInt(qtyInput.value, 10) || 1
      })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var countEl = document.querySelector('.cart-count');
        if (countEl) countEl.textContent = cart.item_count;
        submitText.textContent = 'Dodano ✓';
        setTimeout(function () {
          submitText.textContent = originalText;
          submitBtn.disabled = false;
        }, 1800);
      })
      .catch(function () {
        submitText.textContent = originalText;
        submitBtn.disabled = false;
        window.location.href = '/cart';
      });
  });
})();
